export const FRONTEND_STORAGE_KEYS = {
  entered_the_page_first_time_at: "entered_the_page_first_time_at",
  PAYMENT_METHOD_FAILED_TOP_BAR: "PAYMENT_METHOD_FAILED_TOP_BAR",
  complete_profile_top_bar_dismissed_at:
    "complete_profile_top_bar_dismissed_at",
  is_bookmarks_introduced: "is_bookmarks_introduced",
  working_hours_coach_mark_shown: "working_hours_coach_mark_shown",
  is_employer_dashboard_modal_introduced: "is_air_ai_introduced",
  air_ai_top_bar_dismissed_at: "air_ai_top_bar_dismissed_at",
  EMPLOYER_INVOICES_SELECTION_INTRODUCED_AT:
    "EMPLOYER_INVOICES_SELECTION_INTRODUCED_AT",
  freelancer_billing_announcement_shown:
    "freelancer_billing_announcement_shown",
};

export type FrontendStorageKey = ObjectValues<typeof FRONTEND_STORAGE_KEYS>;
